var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from 'react';
import { MessageAudio } from '../messageAudio';
import fileFetch from './utils/fileFetch';
export default class MessagePhone extends PureComponent {
    constructor(props) {
        super(props);
    }
    render() {
        const _a = this.props, { recordingURL } = _a, otherProps = __rest(_a, ["recordingURL"]);
        if (!recordingURL) {
            return null;
        }
        const download = fileFetch(recordingURL, true);
        return (_jsx(MessageAudio, Object.assign({}, otherProps, { title: "Call recording", onDownload: () => {
                if (typeof download === 'function') {
                    download();
                }
            }, soundfile: {
                src: fileFetch(recordingURL),
                type: 'audio/mp3',
            } })));
    }
}
